var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFingerprint = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.743 24.707c.023-.04.047-.08.072-.119a18.555 18.555 0 0 0 2.851-9.921 5.333 5.333 0 0 1 10.667 0c0 1.356-.092 2.691-.27 4m-2.824 9.124a29.175 29.175 0 0 0 1.989-5.124m5.118 1.509a34.687 34.687 0 0 0 1.32-9.51C26.667 8.777 21.892 4 16 4c-1.943 0-3.764.52-5.333 1.427M4 20.485a13.28 13.28 0 0 0 1.333-5.818c0-1.943.52-3.765 1.427-5.334M16 14.667c0 4.69-1.345 9.065-3.67 12.761",
  stroke: "currentColor",
  strokeWidth: 2.667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgFingerprint;